import InstallerList from "./installer-list"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { notification } from "antd"

notification.config({
  duration: 1,
  rtl: true,
})

const PackageInstaller = props => {
  const { t, openNotification } = props
  return <InstallerList translate={t} openNotification={openNotification} />
}

export default withRouter(withTranslation()(PackageInstaller))
